import css from './sass/style.scss';

require('./js/anims');
require('./js/book');
require('./js/boxes');
require('./js/polyfills');
require('./js/cards');
require('./js/carousels');
//require('./js/cookies');
require('./js/countup');
require('./js/erecruter-offer');
require('./js/findplace');
require('./js/fb');
//require('./js/fb-frontline');
require('./js/glightbox');
require('./js/helpers');
require('./js/herovideo');
require('./js/init');
require('./js/inview');
require('./js/ismobile');
require('./js/lazy');
require('./js/nav');
require('./js/no-widows');
require('./js/offers');
require('./js/scrollpos');
require('./js/simplebar');
require('./js/smoothscroll');
require('./js/sticky');
require('./js/text-roller');
require('./js/videolist');
require('./js/waypoints');
require('./js/whatsnew');
